import { format } from 'date-fns';

import { snakizeObject } from '@cvt/helpers/object';
import { mapStoryDataForApi } from '@modules/Stories/client/helpers';


export const mapMeetingCrudData = (data: Partial<Meetings.Edit>): Meetings.CrudApi => {
  const apiData: Meetings.CrudApi = snakizeObject(data);
  if (data.storiesThrough && data.storiesThrough.length > 0) {
    apiData.stories_through = data.storiesThrough.map(storyThrough => {
      const processedStoryThrough = { ...storyThrough };

      if (processedStoryThrough.story) {
        processedStoryThrough.story = mapStoryDataForApi(processedStoryThrough.story) as Stories.Edit;
      }

      return snakizeObject(processedStoryThrough);
    });
  }

  return {
    ...apiData,
    date: data.date && format(data.date, 'yyyy-MM-dd'),
  };
};
